var render = function render(){var _vm=this,_c=_vm._self._c;return _c('row',[_c('col8',[(_vm.workers.length > 0)?_c('v-card',{staticStyle:{"margin-bottom":"30px"},attrs:{"color":"rgb(247, 245, 243)","sticky":true}},[_c('v-card-text',_vm._l((_vm.workers),function(worker){return _c('worker',{key:worker.id,attrs:{"worker":worker}})}),1)],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }